// src/components/erp/general/DashboardButtons.jsx
import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import './../../style/Vars.css'
import './../../style/ElementsStyle.css'
import './../../style/ContainersStyles.css'
import {
  FaUserCircle,
  FaHome,
  FaBell,
  FaEnvelope,
  FaCog
} from 'react-icons/fa';

const modules = [
  { name: 'LIVING ROOM', devices: 6, icon: '🛏️' },
  { name: 'ROOM 1', devices: 4, icon: '🛏️' },
  { name: 'ROOM 2', devices: 2, icon: '🛏️' },
  { name: 'KITCHEN', devices: 3, icon: '🍳' },
  { name: 'OFFICE', devices: 8, icon: '💻' },
  { name: 'GARDEN', devices: 5, icon: '🌱' }
];

export default function PanelSigmaKey() {
  const isSmallDevice = isMobile || isTablet;

  return (
    <div className="panel-sigma-layout">
      {/* Sidebar adaptativo */}
      <aside
        className={`panel-sigma-sidebar ${
          isSmallDevice ? 'panel-sigma-sidebar-responsive' : ''
        }`}
      >
        {!isSmallDevice && (
          <div className="panel-sigma-avatar">
            <FaUserCircle size={48} />
          </div>
        )}
        <nav className="panel-sigma-nav">
          <br></br>
          <button><FaHome /></button> <br></br><br></br>
          <button className="notif-active"><FaBell /></button><br></br><br></br>
          <button><FaEnvelope /></button><br></br><br></br>
          <button><FaCog /></button><br></br><br></br>
        </nav>
      </aside>

      {/* Main content */}
      <main className="panel-sigma-main">
        <h2 className="panel-sigma-title">MY DASHBOARD</h2>

        <div className="panel-sigma-search">
          <input type="text" placeholder="Search..." />
          <button>🔍</button>
        </div>

        <div className="panel-sigma-modules">
          {modules.map((mod, idx) => (
            <div key={idx} className="panel-sigma-card">
              <div className="panel-sigma-devices">
                {mod.devices} Devices
              </div>
              <div className="panel-sigma-icon">{mod.icon}</div>
              <div className="panel-sigma-label">{mod.name}</div>
            </div>
          ))}
        </div>

        <div className="panel-sigma-footerplayer">
          <div className="panel-sigma-footericon">
            <FaUserCircle size={32} />
          </div>
          <div className="panel-sigma-footertext">
            <div className="footer-title">Lorem ipsum</div>
            <div className="footer-subtitle">Consectetuer adipiscing</div>
          </div>
          <div className="panel-sigma-playercontrols">
            <button>⏮</button>
            <button>⏸</button>
            <button>⏭</button>
          </div>
        </div>
      </main>
    </div>
  );
}
